// extracted by mini-css-extract-plugin
export var box = "BurgerBtn-module--box--35ed0";
export var box_md = "BurgerBtn-module--box_md--a74fa";
export var box_xmd = "BurgerBtn-module--box_xmd--6a417";
export var box_flex = "BurgerBtn-module--box_flex--fc938";
export var box_lg = "BurgerBtn-module--box_lg--452ad";
export var box_sm = "BurgerBtn-module--box_sm--97f4e";
export var box_outer = "BurgerBtn-module--box_outer--060fa";
export var box_whiteBg = "BurgerBtn-module--box_white-bg--9e8b2";
export var box_noMarginBottom = "BurgerBtn-module--box_no-margin-bottom--a6037";
export var box_noPadding = "BurgerBtn-module--box_no-padding--bede7";
export var box_outerGray = "BurgerBtn-module--box_outer-gray--67a02";
export var box_dark = "BurgerBtn-module--box_dark--759ff";
export var box_zIndex = "BurgerBtn-module--box_z-index--27a8a";
export var box_zIndex6 = "BurgerBtn-module--box_z-index-6--2e48f";
export var box_eventsWithLine = "BurgerBtn-module--box_events-with-line--e5604";
export var box_featuresAo = "BurgerBtn-module--box_features-ao--4f5ee";
export var box_verticalPaddings = "BurgerBtn-module--box_vertical-paddings--a381e";
export var clearP = "BurgerBtn-module--clearP--4ab22";
export var clearP_vc = "BurgerBtn-module--clearP_vc--8bfd5";
export var button = "BurgerBtn-module--button--c0b43";
export var active = "BurgerBtn-module--active--d2975";
export var wrapper = "BurgerBtn-module--wrapper--b47b1";
export var fixed = "BurgerBtn-module--fixed--8ebf3";
export var fadeInAnimation = "BurgerBtn-module--fadeInAnimation--0adbc";
export var placeHolderShimmer = "BurgerBtn-module--placeHolderShimmer--15ff8";